export default {
  addEventListener (el, event, fn) {
    el.addEventListener(event, fn)
  },

  removeEventListener (el, event, fn) {
    el.removeEventListener(event, fn)
  },

  browserLocale () {
    return (navigator.language || navigator.userLanguage).match(/[a-z]+/)[0]
  },

  isMobile () {
    let width = window.innerWidth || document.body.clientWidth
    return (width <= process.env['MOBILE_DEVICE_WIDTH'])
  }
}



// WEBPACK FOOTER //
// ./src/multipay/services/browser.js